import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const fresnoNeighborhoods = [
    { name: 'Tower District', slug: 'tower-district' },
    { name: 'Woodward Park', slug: 'woodward-park' },
    { name: 'Fig Garden', slug: 'fig-garden' },
    { name: 'North Fresno', slug: 'north-fresno' },
    { name: 'Downtown Fresno', slug: 'downtown-fresno' },
    { name: 'Sunnyside', slug: 'sunnyside' },
    { name: 'Bullard', slug: 'bullard' },
    { name: 'Fresno Bluffs', slug: 'fresno-bluffs' },
    { name: 'West Fresno', slug: 'west-fresno' },
    { name: 'Southeast Fresno', slug: 'southeast-fresno' },
  ];

  const nearbyAreas = [
    { name: 'Clovis', path: '/areas/clovis' },
    { name: 'Madera', path: '/areas/madera' },
    { name: 'Visalia', path: '/areas/visalia' },
    { name: 'Hanford', path: '/areas/hanford' },
    { name: 'Tulare', path: '/areas/tulare' },
    { name: 'Selma', path: '/areas/selma' },
    { name: 'Sanger', path: '/areas/sanger' },
    { name: 'Reedley', path: '/areas/reedley' },
    { name: 'Dinuba', path: '/areas/dinuba' },
    { name: 'Porterville', path: '/areas/porterville' },
    { name: 'Fowler', path: '/areas/fowler' },
  ];

  return (
    <footer className="bg-[#111] text-white">
      {/* Main footer grid */}
      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

          {/* Brand column */}
          <div>
            <div className="mb-4">
              <img src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/2ee0947c9c88164b430bbd11db9ffeb9.png" alt="Electrician Solutions Fresno" className="h-20 w-auto object-contain" />
            </div>
            <p className="text-gray-400 mb-6 text-sm">Fresno's Trusted Licensed Electrical Contractor</p>

            <div className="space-y-4 mb-6">
              <div>
                <h4 className="text-[#FFD700] font-bold text-xs uppercase mb-1">License</h4>
                <p className="text-gray-300 text-sm">C-10 Electrical Contractor</p>
                <p className="text-gray-300 text-sm">California State License Board Certified</p>
              </div>
              <div>
                <h4 className="text-[#FFD700] font-bold text-xs uppercase mb-1">Certification</h4>
                <p className="text-gray-300 text-sm">California General Electricians Exam - Passed</p>
                <p className="text-gray-300 text-sm">Certified Electrical Safety Compliance</p>
              </div>
              <div>
                <h4 className="text-[#FFD700] font-bold text-xs uppercase mb-1">Memberships</h4>
                <p className="text-gray-300 text-sm">NECA Certified Member</p>
                <p className="text-gray-300 text-sm">BBB Accredited Business - A+ Rating</p>
                <p className="text-gray-300 text-sm">Fully Licensed, Bonded &amp; Insured</p>
              </div>
            </div>

            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center border border-gray-600 rounded-full hover:border-[#FFD700] hover:text-[#FFD700] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center border border-gray-600 rounded-full hover:border-[#FFD700] hover:text-[#FFD700] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center border border-gray-600 rounded-full hover:border-[#FFD700] hover:text-[#FFD700] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
              <a href="https://yelp.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center border border-gray-600 rounded-full hover:border-[#FFD700] hover:text-[#FFD700] transition-colors cursor-pointer">
                <i className="ri-yelp-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Services + Company */}
          <div>
            <h4 className="text-[#FFD700] font-bold text-xs uppercase mb-4">Services</h4>
            <ul className="space-y-2 mb-6">
              <li><Link to="/services/residential-electrical" className="text-gray-300 hover:text-[#FFD700] transition-colors text-sm">Residential Electrical</Link></li>
              <li><Link to="/services/testing-certification" className="text-gray-300 hover:text-[#FFD700] transition-colors text-sm">Testing &amp; Certification</Link></li>
              <li><Link to="/services/repairs-maintenance" className="text-gray-300 hover:text-[#FFD700] transition-colors text-sm">Repairs &amp; Maintenance</Link></li>
              <li><Link to="/services/lighting-outdoor" className="text-gray-300 hover:text-[#FFD700] transition-colors text-sm">Lighting &amp; Outdoor Electrical</Link></li>
              <li><Link to="/services/commercial-specialist" className="text-gray-300 hover:text-[#FFD700] transition-colors text-sm">Commercial &amp; Specialist</Link></li>
              <li><Link to="/services/smart-home-energy" className="text-gray-300 hover:text-[#FFD700] transition-colors text-sm">Smart Home &amp; Energy</Link></li>
              <li><Link to="/services/renewables-ev" className="text-gray-300 hover:text-[#FFD700] transition-colors text-sm">Renewables &amp; EV</Link></li>
              <li><Link to="/services/fire-safety" className="text-gray-300 hover:text-[#FFD700] transition-colors text-sm">Fire Safety</Link></li>
            </ul>

            <h4 className="text-[#FFD700] font-bold text-xs uppercase mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/blog" className="text-gray-300 hover:text-[#FFD700] transition-colors text-sm">Electrical Blog &amp; Guides</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-[#FFD700] transition-colors text-sm">Contact Us</Link></li>
              <li><Link to="/sitemap" className="text-gray-300 hover:text-[#FFD700] transition-colors text-sm">Sitemap</Link></li>
            </ul>
          </div>

          {/* Fresno Neighborhoods */}
          <div>
            <h4 className="text-[#FFD700] font-bold text-xs uppercase mb-4">Fresno Neighborhoods We Serve</h4>
            <ul className="space-y-2 mb-6">
              {fresnoNeighborhoods.map(n => (
                <li key={n.slug}>
                  <a href={`/?area=${n.slug}`} className="text-gray-300 hover:text-[#FFD700] transition-colors text-sm flex items-center gap-2 cursor-pointer">
                    <i className="ri-map-pin-line text-[#FFD700] text-xs flex-shrink-0"></i>
                    Electrician in {n.name}
                  </a>
                </li>
              ))}
            </ul>

            <h4 className="text-[#FFD700] font-bold text-xs uppercase mb-4">Nearby Cities</h4>
            <div className="flex flex-wrap gap-2">
              {nearbyAreas.slice(0, 6).map(area => (
                <Link key={area.path} to={area.path} className="text-xs text-gray-400 hover:text-[#FFD700] transition-colors border border-gray-700 hover:border-[#FFD700] px-2 py-1 rounded-full whitespace-nowrap cursor-pointer">
                  {area.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact + Hours */}
          <div>
            <h4 className="text-[#FFD700] font-bold text-xs uppercase mb-4">Contact Us</h4>
            <a href="mailto:info@electriciansolutionsfresno.com" className="text-gray-300 hover:text-[#FFD700] transition-colors block mb-4 text-sm cursor-pointer">
              info@electriciansolutionsfresno.com
            </a>
            <p className="text-gray-400 text-sm mb-6">
              Serving Fresno, CA<br />
              and all surrounding Central Valley areas
            </p>

            <div className="bg-[#FFD700] text-[#1a1a1a] px-6 py-4 rounded-lg mb-6">
              <h4 className="font-bold text-xs uppercase mb-2">Hours</h4>
              <p className="font-bold text-sm">24/7 Emergency Service</p>
              <p className="text-xs mt-2">Mon–Fri: 7:00 AM – 6:00 PM</p>
              <p className="text-xs">Sat: 8:00 AM – 4:00 PM</p>
              <p className="text-xs">Sun: Emergency Only</p>
            </div>

            <h4 className="text-[#FFD700] font-bold text-xs uppercase mb-3">From Our Blog</h4>
            <ul className="space-y-2">
              {[
                { title: 'When to Upgrade Your Panel', slug: 'when-to-upgrade-electrical-panel-fresno' },
                { title: 'EV Charger Installation Guide', slug: 'ev-charger-installation-fresno-homeowners' },
                { title: 'Home Electrical Safety Checklist', slug: 'fresno-home-electrical-safety-checklist' },
              ].map(p => (
                <li key={p.slug}>
                  <Link to={`/blog/${p.slug}`} className="text-gray-400 hover:text-[#FFD700] transition-colors text-xs flex items-start gap-2 cursor-pointer">
                    <i className="ri-article-line text-[#FFD700] flex-shrink-0 mt-0.5"></i>
                    {p.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* All nearby areas strip */}
      <div className="border-t border-gray-800">
        <div className="max-w-[1400px] mx-auto px-6 py-6">
          <p className="text-gray-600 text-xs uppercase tracking-widest mb-3">Electrician Services Also Available In:</p>
          <div className="flex flex-wrap gap-2">
            {nearbyAreas.map(area => (
              <Link key={area.path} to={area.path} className="text-xs text-gray-500 hover:text-[#FFD700] transition-colors cursor-pointer whitespace-nowrap">
                Electrician {area.name}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-[1400px] mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-xs">
            © {currentYear} Electrician Solutions Fresno. All rights reserved. Licensed C-10 Electrical Contractor.
          </p>
          <div className="flex gap-6 text-xs">
            <Link to="/privacy" className="text-gray-500 hover:text-[#FFD700] transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-500 hover:text-[#FFD700] transition-colors">Terms of Service</Link>
            <Link to="/blog" className="text-gray-500 hover:text-[#FFD700] transition-colors">Blog</Link>
            <Link to="/sitemap" className="text-gray-500 hover:text-[#FFD700] transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
